var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistBorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 126,
    viewBox: "0 0 225 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5758 121.276C11.1603 123.443 13.2219 125.043 15.6754 125.043H201.282C214.368 125.043 224.976 114.925 224.976 102.443V12.6684C224.976 10.2413 223.171 8.2163 220.772 7.74805C220.924 8.64308 221.01 9.55926 221.025 10.4919C221.813 10.9258 222.343 11.738 222.343 12.6684V102.443C222.343 113.538 212.914 122.532 201.282 122.532H15.6754C14.7009 122.532 13.85 122.027 13.3948 121.276H10.5758Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76855 116.468C6.35307 118.635 8.41462 120.237 10.8681 120.237H200.423C211.328 120.237 220.169 111.8 220.169 101.394V7.80785C220.169 5.46652 218.491 3.49921 216.22 2.94141V5.6316C217.007 6.066 217.536 6.87792 217.536 7.80785V101.394C217.536 105.19 216.179 108.684 213.902 111.457C213.094 112.538 212.102 113.485 210.969 114.256C208.063 116.429 204.402 117.724 200.423 117.724H10.8681C9.89362 117.724 9.0428 117.219 8.58759 116.468H5.76855Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistBorders);
export default __webpack_public_path__ + "static/media/playlist-borders.f8b120722eeadfcdd1dce05c648d6f3b.svg";
export { ForwardRef as ReactComponent };